import { AssessmentOutlined } from '@mui/icons-material';
import { WidgetIcon } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModulePageHeader } from '~/components/ModulePageHeader/ModulePageHeader';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ModuleSlotId } from '~/modules';
import { RouteId } from '~/routes';

export const CoverageAssistant = () => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'CoverageAssistant' });

  const { modules, maxWidth } = useModulePageConfig({ pageId: RouteId.coverageAssistant });

  return (
    <ModulePage
      maxWidth={maxWidth}
      header={
        <ModulePageHeader title={t('title')} icon={<WidgetIcon icon={<AssessmentOutlined fontSize="small" />} />} />
      }
      modules={<ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />}
    />
  );
};
